import type { TOC } from '@ember/component/template-only';
import BaseSummary from 'parog-web/components/mici/base-summary';
import type Patient from 'parog-web/models/patient';
interface Signature {
  Args: {
    patient: Patient;
  };
}

export default <template>
  <BaseSummary
    @patient={{@patient}}
    @title='Historique des questionnaires Crohn'
    @feature='mici'
    @component='crohn-survey-consult-form'
    @modelName='crohn-survey-filled-journal-event'
  />
</template> satisfies TOC<Signature>;
